import styled from 'styled-components';
import { Typography } from 'src/ui/common/atoms/typography';

export const StyledItem = styled.div`
  margin-right: 5px;
  min-width: 0;
  
  & > *:first-child {
    margin-bottom: 5px;
  }
`;

export const StyledItemValue = styled.div`
  color: ${({ theme }) => theme.colors.white};
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 20px;
`;

export const StyledLaunchpadNameWrapper = styled(Typography)`
white-space: pre-wrap;
`;